import * as React from 'react';
import { ModuleMarkdownGuide } from './common/module-markdown-guide';

const userGuideChapterMarkdownFiles = import.meta.glob(
  '/public/resources/docs/user-guide/chapters/*.md',
  {
    query: '?raw',
    import: 'default',
  },
);

const UserGuide: React.FC = () => {
  return (
    <ModuleMarkdownGuide
      chapterMarkdownFiles={userGuideChapterMarkdownFiles}
      chaptersPublicBasePath="/resources/docs/user-guide/chapters"
      guideDisplayTitle="Ops Portal User Guide"
    />
  );
};

export default UserGuide;
